import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { useInventoryAdjustmentQuery } from '../../../hooks/inventory/useInventoryAdjustmentQuery';
import CreateInventoryAdjustmentModal from '../adjustment/Modals/CreateInventoryAdjustmentModal';

const InventoryAdjustmentButton: React.FC = () => {
  const {
    showAdjustmentModal,
    handlerOpenAdjustmentModal,
    handlerCloseAdjustmentModal,
  } = useInventoryAdjustmentQuery();

  return (
    <>
      {/* 🔘 Botón principal */}
      <button
        type="button"
        onClick={handlerOpenAdjustmentModal}
        className="
          flex items-center justify-center gap-2
          rounded bg-primary px-4.5 py-2.5
          text-sm font-medium text-white
          hover:bg-opacity-90 transition
        "
      >
        <SlidersHorizontal className="h-4 w-4" />
        <span className="leading-tight">Ajuste de Inventario</span>
      </button>

      {/* 🪟 Modal de creación de ajuste */}
      <CreateInventoryAdjustmentModal
        isOpen={showAdjustmentModal}
        onClose={handlerCloseAdjustmentModal}
      />
    </>
  );
};

export default InventoryAdjustmentButton;
